import { Directive, Renderer2, HostListener } from '@angular/core';

@Directive({
  selector: '[ssShrinkMenu]',
  standalone: false
})
export class ShrinkMenuDirective {

  constructor(
    private render: Renderer2) {
  }

  @HostListener('click')
  onMouseClick() {
    const menu: any = document.querySelector('.ss-side-menu');
    const submenu: any = document.querySelectorAll('.ss-side-submenu');
    const container: any = document.querySelector('.ss-main-container');
    const reduceLink: any = document.querySelector('#shrink-menu');
    const reduceText: any = document.querySelectorAll('#shrink-menu span')[1];
    const itemsWithTooltip: any = menu ? menu.querySelectorAll('[data-tooltip-label]') : [];

    if (menu.classList.contains('is-reduced')) {
      this.render.removeClass(menu, 'is-reduced');
      if (container) {
        this.render.removeClass(container, 'menu-is-reduced');
      }
      if (reduceLink) {
        this.render.removeClass(reduceLink, 'is-reduced');
        this.render.setAttribute(reduceLink, 'aria-label', 'Reduzir menu');
        this.render.setAttribute(reduceLink, 'data-tooltip-label', 'Reduzir menu');
        this.render.removeAttribute(reduceLink, 'title');
        this.render.removeAttribute(reduceLink, 'data-ss-tooltip');
      }

      if (reduceText) {
        reduceText.innerHTML = 'Reduzir';
      }

      for (let i = 0; i < submenu.length; i++) {
        this.render.removeClass(submenu[i], 'is-reduced');
      }
      for (let i = 0; i < itemsWithTooltip.length; i++) {
        this.render.removeAttribute(itemsWithTooltip[i], 'data-ss-tooltip');
        this.render.removeAttribute(itemsWithTooltip[i], 'title');
      }
      return;
    }

    this.render.addClass(menu, 'is-reduced');
    if (container) {
      this.render.addClass(container, 'menu-is-reduced');
    }
    if (reduceLink) {
      this.render.addClass(reduceLink, 'is-reduced');
      this.render.setAttribute(reduceLink, 'aria-label', 'Expandir menu');
      this.render.setAttribute(reduceLink, 'data-tooltip-label', 'Expandir menu');
    }

    if (reduceText) {
      reduceText.innerHTML = 'Expandir';
    }

    for (let i = 0; i < submenu.length; i++) {
      this.render.addClass(submenu[i], 'is-reduced');
    }
    for (let i = 0; i < itemsWithTooltip.length; i++) {
      const label = itemsWithTooltip[i].getAttribute('data-tooltip-label');
      if (label) {
        this.render.setAttribute(itemsWithTooltip[i], 'data-ss-tooltip', label);
      }
    }

  }

}
